import {
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import Image from "next/image";
import { ChangeEvent, useCallback } from "react";

interface InputAmountProps {
  icon: any;
  coinName: string;
  setAmount: (amount?: number) => void;
  amount?: number;
  handleMaxClick: () => void | null;
  error: string | null;
  disableMaxButton?: boolean;
  showMaxButton?: boolean;
  showError?: boolean;
}

export const InputAmount = ({
  icon,
  coinName,
  setAmount,
  amount,
  handleMaxClick,
  error,
  disableMaxButton = false,
  showMaxButton = false,
  showError = false,
}: InputAmountProps) => {
  const handleInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = Number(e?.target?.value) || undefined;
      setAmount(value);
    },
    [setAmount]
  );

  return (
    <>
      <InputGroup size={"lg"} my={"24px"}>
        <InputLeftElement mt={"5px"}>
          <Image src={icon} alt={coinName} width={24} height={24} />
        </InputLeftElement>

        <Input
          placeholder={`Enter ${coinName} amount`}
          height="56px"
          onChange={handleInputChange}
          onKeyPress={(e) => {
            if (e.key === "-" || e.key === "+") {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
          }}
          type="number"
          value={amount ?? ""}
          borderWidth="1px"
          borderColor={
            showError && error ? "brand.errorColor" : "brand.primary"
          }
          fontSize="1rem"
          _focus={{
            borderColor:
              showError && error ? "brand.errorColor" : "brand.primary",
            boxShadow: "none",
          }}
          _hover={{
            borderColor:
              showError && error ? "brand.errorColor" : "brand.primary",
            boxShadow: "none",
          }}
        />
        {showMaxButton && (
          <InputRightElement mt="5px" mr="8px">
            <Button
              onClick={() => handleMaxClick()}
              disabled={disableMaxButton}
              _hover={{
                background: "brand.primary",
                color: "brand.primaryText",
              }}
            >
              <Text className="h5">Max</Text>
            </Button>
          </InputRightElement>
        )}
      </InputGroup>
    </>
  );
};
